module.exports = __webpack_public_path__ + "media/cards/21-7f4b4159.png";